import React from "react";

import { useIntlTranslate } from "../../../../../hooks";
import { useBarChartContext } from "../../BarChartProvider";

export const ChartNoDataMessage = () => {
  const translate = useIntlTranslate();
  const { topOffset } = useBarChartContext();

  return (
    <g className={"no-data-message"}>
      <text
        x="50%"
        transform={`translate(0, ${topOffset / 2})`}
        textAnchor="middle"
      >
        {translate("no_available_data")}
      </text>
    </g>
  );
};
